import type { IChartDataResult } from "@/pages/CreatorAnalytics/types";

export const stripHiddenColumns = (chartData: IChartDataResult, hidden: Set<number>): IChartDataResult => {
  if (hidden.size === 0) {
    return chartData;
  }

  const visibleIndices = chartData.columns.map((col, i) => i).filter((i) => i === 0 || !hidden.has(i - 1));

  return {
    columns: visibleIndices.map((i) => chartData.columns[i]),
    rows: chartData.rows.map((row) => visibleIndices.map((i) => row[i])),
    colors: chartData.colors.filter((color, i) => !hidden.has(i)),
    vAxisTitle: chartData.vAxisTitle,
  };
};
